module.exports = __webpack_public_path__ + "static/media/maintenance-bg-mobile.fe4bfb4b.png";